// extracted by mini-css-extract-plugin
export default {"side-menu-header":"SideMenuHeader_side-menu-header__vZclf","side-menu-filters":"SideMenuHeader_side-menu-filters__Ikl3d"};